<template>
  <div>
    <van-nav-bar
      :title="$t('app.protocol.title')"
      :left-text="$t('app.common.back')"
      left-arrow
      onclick="window.history.go(-1)"
    />
    <div class="content" v-html="content">

    </div>
  </div>
</template>

<script>
export default {
  name: "Protocol",
  data(){
    return{
      content:''
    }
  },
  methods:{
    getContent(){
      let that = this;
      let type = that.$route.query.type;
      if (type){
        that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "protocol",
              type:type,
            }
          })
          .then(function(res) {
            let resData = res.data;
            if (res.data.code === 1) {
              that.content = resData.data
            } else {
              that.$toast.fail(this.$t('app.protocol.wrong_entry'));
            }
          });
      }else{
        // console.log(2222)
      }
    }
  },
  mounted:function (){
    let that = this;
    that.getContent();
  }
}
</script>

<style scoped>
  .content{
    width: 90%;
    margin: 0 auto;
  }
  .content >>> img{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Protocol.vue